import { useUserStore } from 'shared/state/user';
import { useMemo } from 'react';
import { marketByCountryCode, marketByLanguageCode } from 'shared/library/i18n/market';
import { useTranslation } from 'react-i18next';
import { getSafeLanguageCode } from 'shared/library/i18n/languages';

export function useLocale() {
  const { i18n } = useTranslation();
  const languageCode = getSafeLanguageCode(i18n.language);
  const user = useUserStore((s) => s.user);

  const countryCode = useMemo(() => {
    if (user?.country) {
      return marketByCountryCode(user.country)?.country_code ?? 'SE';
    }

    return marketByLanguageCode(languageCode)?.country_code ?? 'SE';
  }, [user?.country, languageCode]);

  const timezone = useMemo(() => {
    return 'Europe/Stockholm';
  }, []);

  const locale = useMemo(() => {
    return countryCode ? `${languageCode}-${countryCode}` : languageCode;
  }, [languageCode, countryCode]);

  const market = useMemo(() => {
    return marketByCountryCode(countryCode) ?? marketByCountryCode('SE')!;
  }, [countryCode]);

  return { locale, languageCode, countryCode, timezone, market };
}
